var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "Checklist",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M46 8v54H4V8h8v5h26V8h8z",
    className: "coloreeecff svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M38 6v7H12V6h9a4 4 0 0 1 8 0Z",
    className: "coloree161f svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M60 10v5h-9v-5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2Z",
    className: "colorff9909 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bbbbbb",
    d: "M51 15h9v36h-9z",
    className: "colorffc578 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "m60 51-4.5 10L51 51h9z",
    className: "colorff9909 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "m11.75 23.92-2.34-2.33-2.82 2.82 4 4A2 2 0 0 0 12 29h.17a2 2 0 0 0 1.46-.83l5-7-3.26-2.32ZM21 22h22v4H21zM11.75 35.92l-2.34-2.33-2.82 2.82 4 4A2 2 0 0 0 12 41h.17a2 2 0 0 0 1.46-.83l5-7-3.26-2.32ZM21 34h22v4H21zM11.75 47.92l-2.34-2.33-2.82 2.82 4 4A2 2 0 0 0 12 53h.17a2 2 0 0 0 1.46-.83l5-7-3.26-2.32ZM21 46h22v4H21z",
    className: "color00459a svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.969c3997db7c7d47c4930ce16b8f0424.svg";
export { ForwardRef as ReactComponent };